export default __webpack_public_path__ + "static/media/background.5d4a2a26.png";